import 'webui-popover'
import 'webui-popover'

$(function() {
    $('.tm-popover').webuiPopover();
});


// WEBPACK FOOTER //
// ./assets/js/popover.js